module.exports = fox._r("fonts/museosanscyrl_2-webfont.svg", __webpack_public_path__ + "fonts/museosanscyrl_2-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_2-webfont.svg
// module id = 586
// module chunks = 2